import { axiosV1 } from 'interceptors/axios';
import types from 'redux/actions/actionTypes';
import { decryptResponse } from 'utils/token';

import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams, Encumbrance } from 'types';
import { Dispatch } from 'redux';

type CreateEcumbranceProps = {
  encumbranceData: Partial<Encumbrance>;
};

type GetEncumbrancesProps = {
  shareId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
  updateState?: boolean;
};

type EncumbrancesApiGetAllResponse = {
  data: Encumbrance[];
  total: number;
};

export type EncumbranceMutationResponse = {
  encumbrance: Encumbrance | null;
};

type UpdateEncumbranceProps = {
  encumbranceId: string;
  updateEncumbranceData: Partial<Encumbrance>;
};

type DeleteEncumbranceProps = {
  encumbranceId: string;
};

export const createEncumbrance =
  ({ encumbranceData }: CreateEcumbranceProps) =>
  async (dispatch: Dispatch) => {
    const { data } = await axiosV1.post(`/encumbrances`, encumbranceData);

    const decodedData = (await decryptResponse(
      data
    )) as EncumbranceMutationResponse;

    if (decodedData.encumbrance) {
      dispatch({
        type: types.CREATE_ENCUMBRANCE,
        encumbrance: decodedData.encumbrance,
      });
    }
    return decodedData.encumbrance;
  };

export const getEncumbrances =
  ({
    shareId,
    params = {},
    updateState = true,
    signal,
  }: GetEncumbrancesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.get('/encumbrances', {
        params: {
          shareId,
          ...params,
        },
        // signal,
      });

      const decodedData = (await decryptResponse(
        data
      )) as EncumbrancesApiGetAllResponse;

      if (updateState) {
        dispatch({
          type: types.GET_ENCUMBRANCES,
          encumbrances: decodedData.data,
        });
      }

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const updateEncumbrance =
  ({ encumbranceId, updateEncumbranceData }: UpdateEncumbranceProps) =>
  async (dispatch: Dispatch) => {
    const body = { ...updateEncumbranceData };

    const { data } = await axiosV1.put(`/encumbrances/${encumbranceId}`, body);
    const decodedData = (await decryptResponse(
      data
    )) as EncumbranceMutationResponse;

    dispatch({
      type: types.UPDATE_ENCUMBRANCE,
      encumbrance: decodedData?.encumbrance,
    });
  };

export const deleteEncumbrance =
  ({ encumbranceId }: DeleteEncumbranceProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.delete(`/encumbrances/${encumbranceId}`);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: types.DELETE_ENCUMBRANCE,
        encumbranceId,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
